import { Injectable, Injector, isDevMode } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { CONSTANTS } from '../constants/constants';

@Injectable()
export class HttpMainInterceptor implements HttpInterceptor {
  constructor(
    private notifications: NotificationsService,
    private router: Router,
    private injector: Injector
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const jwt = localStorage.getItem('jwt') || '';

    if (request.url.indexOf(CONSTANTS.BASE_PAYMENT_API) !== -1) {
      request = request.clone({
        headers: request.headers.set(
          'Authorization',
          'Bearer ' + CONSTANTS.PAYMENT_SECRET_KEY
        ),
      });
    } else if (jwt) {
      request = request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + jwt),
      });
    }

    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          switch (err.status) {
            case 400:
            case 404:
            case 422:
              this.notifications.error(
                'Error!',
                err.error?.message || 'Something went wrong'
              );
              break;
            case 500:
              if (isDevMode()) {
                this.notifications.error(
                  'Internal Server Error, please check API requests!'
                );
              }
              break;
          }
        }

        return throwError(err);
      })
    );
  }

  handleErrors(response: any): void {
    Object.values(response.error.errors).forEach((message) => {
      this.notifications.error('Error!', message);
    });
  }
}
